@if (vm(); as vm) {
  @switch (vm.sidebarType) {
    @case (FlowchartSidebarType.Start) {
      <flowchart-sidebar-start
        class="tt-flowchart-sidebar-wrapper_content"
        [sidebarElement]="vm.element"
        (flowchartElementDataChanged)="handleFlowchartElementDataChanged($event)" />
    }
    @case (FlowchartSidebarType.Action) {
      <flowchart-sidebar-action
        class="tt-flowchart-sidebar-wrapper_content"
        [sidebarElement]="vm.element"
        (flowchartElementDataChanged)="handleFlowchartElementDataChanged($event)" />
    }
    @case (FlowchartSidebarType.Container) {
      <flowchart-sidebar-container
        class="tt-flowchart-sidebar-wrapper_content"
        [sidebarElement]="vm.element"
        (flowchartElementDataChanged)="handleFlowchartElementDataChanged($event)" />
    }
    @case (FlowchartSidebarType.Decision) {
      <flowchart-sidebar-decision
        class="tt-flowchart-sidebar-wrapper_content"
        [sidebarElement]="vm.element"
        (flowchartElementChanged)="handleFlowchartElementDataChanged($event)" />
    }
    @case (FlowchartSidebarType.Link) {
      <flowchart-sidebar-link
        class="tt-flowchart-sidebar-wrapper_content"
        [sidebarElement]="vm.element"
        (flowchartElementDataChanged)="handleFlowchartElementDataChanged($event)" />
    }
    @case (FlowchartSidebarType.TextBlock) {
      <flowchart-sidebar-textblock
        class="tt-flowchart-sidebar-wrapper_content"
        [sidebarElement]="vm.element"
        (flowchartElementDataChanged)="handleFlowchartElementDataChanged($event)" />
    }
  }

  @if (vm.showAddCommentButton) {
    <div class="tt-flowchart-sidebar-wrapper_comment">
      <button ttButton [type]="'useParentWidth'" [variant]="'transparent'" (click)="service.addCommentToElement()">
        <mat-icon [icon]="'message-square-text'" />
        {{ 'Comments.AddComment' | transloco }}
      </button>
    </div>
  }
}
